module.exports = __webpack_public_path__ + "static/media/tankTruck_pink.d719be6e.svg";